import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MosError } from 'src/utils/errors/MosError';

export interface SyncFromLOSResponse {
  success: boolean;
  data: {
    syncTaskId: string;
    message: string;
  };
}

const syncFromLOS: MutationFunction<SyncFromLOSResponse, void> = async () => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SyncFromLOSResponse>(
    `/loans/sync-pipeline`,
    {
      method: 'POST',
    },
  );
  if (response.data) {
    return response.data;
  }
  throw new MosError({
    error: 'Failed to sync from LOS',
    statusCode: response.status,
  });
};

export default syncFromLOS;

const _mockData: SyncFromLOSResponse = {
  success: true,
  data: {
    syncTaskId: 'mock-1',
    message: 'Sync from LOS request accepted',
  },
};
